<template>
    <div class="flex h-screen items-center justify-center">
        <div class="-mt-36">
            <h1 class="text-[6rem] lg:text-[8rem] transition-all duration-300 ease-over-out origin-top-left" v-bind:class="{'opacity-0 -translate-y-12 -rotate-12': !active}">Hoppla,</h1>
            <h2 class="text-[3rem] lg:text-[4rem] transition-all duration-300 ease-over-out origin-bottom-right delay-300" v-bind:class="{'opacity-0 translate-y-3 -rotate-12': !active}">Nicht gefunden</h2>
            <p class="pb-3 transition-all duration-500 ease-out origin-bottom-right delay-700" v-bind:class="{'opacity-0': !active}">Dies hat nicht geklappt. Bitte versuchen Sie es erneut.</p>
            <div class="transition-all ease-out duration-500 delay-1000" v-bind:class="{'opacity-0 translate-x-3': !active}"><ElementsGoBack auto /></div>

        </div>
    </div>
</template>
<script setup>

const active = ref(false)
onMounted(function(){
    setTimeout(function(){ active.value = true }, 100)
})
onBeforeUnmount(() => active.value = false )
</script>